/** LayerSwitcher control
 * Add a LayerSwitcher control to the map
 */
import map from '../map'
import './layerswitcher.css'

// LayerSwitcher control 
import LayerSwitcher from 'ol-ext/control/LayerSwitcher'


const switcher = new LayerSwitcher({
show_progress: true ,
mouseover: true,
layerGroup:'baseLayers',  // Only show this layer group	
trash: true,
extent:true,	
collapsed: true,
});
map.addControl(switcher);
console.log('Switcher:',switcher);

